import Vue from 'vue'

const responsive = Vue.observable({
  isMobile: window.innerWidth <= 888
})

window.addEventListener('resize', () => {
  responsive.isMobile = window.innerWidth <= 888
})

export default responsive